// src/utils/lazyWithPreload.ts
import { lazy } from "react";

type LazyComponent<T extends React.ComponentType<any>> =
  React.LazyExoticComponent<T> & {
    preload: () => Promise<{ default: T }>;
  };

export function lazyWithPreload<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): LazyComponent<T> {
  const Component = lazy(factory);
  (Component as LazyComponent<T>).preload = factory;
  return Component as LazyComponent<T>;
}
